module.exports = __webpack_public_path__ + "static/img/coupon-on.ba737d93.webp";